import React from "react";
import {GameModes} from "../../../constants/EnumGameModes";
import {GameModePage} from "../GameModePage";


type FastailyType = {}

export const Fastaily: React.FC<FastailyType> = () => {
    return (
        <GameModePage
            gameMode={GameModes.FASTAILY}
            showDifficultySelector={false}
            showBreadcrumb={false}
            containerPadding="xl:px-60"
        />
    );
}
